import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setStage } from 'slices/drawer'
import { fetchContractDetails } from 'slices/contract'
import { STATICS } from 'statics'
import { STORE_STAGES, TV_PLAN_STATUS } from 'app-constants'
import {
  FIFTEEN_SECONDS_IN_MILLISECONDS,
  WITH_PRODUCTS_PENDING_ACTIVATION,
  WITHOUT_PRODUCTS_PENDING_ACTIVATION,
} from '../../constants'
import './style.scss'

export function SuccessActivate({ setActivationInfo }) {
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()
  const { contractId, detail, activationLinks } = useSelector(({ contract }) => ({
    contractId: contract.selected.id,
    detail: contract.detail,
    activationLinks: contract.activationLinks,
  }))

  useEffect(() => {
    dispatch(fetchContractDetails(contractId))
  }, [contractId, dispatch])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false)
    }, FIFTEEN_SECONDS_IN_MILLISECONDS)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  function handleActivateClick(product = {}) {
    const { itemCode } = product

    setActivationInfo({
      product,
      activationLink: activationLinks[itemCode],
    })
    dispatch(setStage(STORE_STAGES.ACTIVATION))
  }

  function getShouldShowProducToActivate(product) {
    const { activeSva, status, itemCode, integrationError } = product
    const hasActivationLink = !!activationLinks[itemCode]
    const isInactive = status === TV_PLAN_STATUS.INACTIVE

    return isInactive && activeSva && !integrationError && hasActivationLink
  }

  function getProductsToActivate() {
    const allContractProducts = detail?.contractAdditionals || []

    return allContractProducts.filter(getShouldShowProducToActivate)
  }

  function renderMessage() {
    const hasProductsPendingActivation = getProductsToActivate()
    let text = WITHOUT_PRODUCTS_PENDING_ACTIVATION

    if (hasProductsPendingActivation.length) text = WITH_PRODUCTS_PENDING_ACTIVATION

    return <span className='description'>{text}</span>
  }

  function renderLoading() {
    if (!isLoading) return null

    return (
      <div className='container-loading'>
        <STATICS.STORE_LOADER />
        <span className='loading-message'>
          Estamos carregando seus serviços, isso pode levar alguns segundos.
        </span>
      </div>
    )
  }

  function renderProductsMessage() {
    if (isLoading) return null

    return renderMessage()
  }

  function renderProducts() {
    const products = getProductsToActivate()

    return products.map(product => {
      const { itemName, urlImage, urlLogo } = product

      return (
        <button type='button' className='container-product'>
          <div className='container-info'>
            <img className='image' src={urlLogo || urlImage} alt={itemName} />
            <span className='text'>{itemName}</span>
          </div>
          <button type='button' className='button' onClick={() => handleActivateClick(product)}>
            Não ativado
          </button>
        </button>
      )
    })
  }

  function renderProductsToActivate() {
    if (isLoading) return null

    return <div className='container-products'>{renderProducts()}</div>
  }

  return (
    <div className='container-activate'>
      <div className='container-message'>
        <STATICS.TOGGLE />
        <div className='container-info'>
          <span className='title'>Serviços disponíveis para ativar:</span>
          {renderProductsMessage()}
        </div>
      </div>
      {renderLoading()}
      {renderProductsToActivate()}
    </div>
  )
}
